<template>
  <div class="listFilter">
    <div class='bg-border'>

      <div class="flex between listFilter-cell">
        <!-- 城市 -->
        <div class="flex align" @click.stop="onShowFilterCell(0)"><span
            :class="(filterIndex=='0'||(!(selProvinceIndex==0&&selCityIndex==0&&selAreaIndex==0)))?'clr-cyan':''">城市</span>
          <img src="../assets/icon-active.svg" class="listFilter-active" v-if="filterIndex=='0'">
          <img src="../assets/icon-normal.svg" class="listFilter-normal" v-else>
        </div>

        <!-- 性别 -->
        <div class="flex align" @click.stop="onShowFilterCell(1)"
          :class="(filterIndex=='1'||selSexIndex!=0)?'clr-cyan':''"><span>性别</span>
          <img src="../assets/icon-active.svg" class="listFilter-active" v-if="filterIndex=='1'||selSexIndex!=0">
          <img src="../assets/icon-normal.svg" class="listFilter-normal" v-else>
        </div>
        <!-- 价格 -->
        <div class="flex align" @click.stop="onShowFilterCell(2)"><span
            :class="(filterIndex=='2'||selPriceIndex!=0)?'clr-cyan':''">价格</span>
          <img src="../assets/icon-active.svg" class="listFilter-active" v-if="filterIndex=='2'||selPriceIndex!=0">
          <img src="../assets/icon-normal.svg" class="listFilter-normal" v-else>
        </div>
        <!-- 其他 -->
        <div class="flex align" @click.stop="onShowFilterCell(3)"
          :class="(filterIndex=='3'||(selForm!=-1||selType!=-1||selSubject!=-1||selTopic!=-1||selLang!=-1))?'clr-cyan':''">
          <span>其他</span>
          <img src="../assets/icon-active.svg" class="listFilter-active"
            v-if="filterIndex=='3'||(selForm!=-1||selType!=-1||selSubject!=-1||selTopic!=-1||selLang!=-1)">
          <img src="../assets/icon-normal.svg" class="listFilter-normal" v-else>
        </div>
      </div>
      <div>
        <template v-if="show">
          <template v-if="filterIndex=='0'">
            <div class="flex">
              <div class="item" :style="'overflow-y: scroll;max-height:'+(Height-220)+'px'">
                <div v-for="(item,akey) in province" :key="akey"
                  :class="['city',selProvinceIndex==akey?'city-active':'']" @click.stop="getCity(item,akey,false)">
                  {{item.shortName}}</div>
              </div>
              <div class="item border-left-right" :style="'overflow-y: scroll;max-height:'+(Height-220)+'px'">
                <div v-for="(item,bkey) in city" :key="bkey" :class="['city',selCityIndex==bkey?'city-active':'']"
                  @click.stop="getArea(item,bkey,false)">{{item.shortName}}</div>
              </div>
              <div class="item" :style="'overflow-y: scroll;max-height:'+(Height-220)+'px'">
                <div v-for="(item,ckey) in area" :key="ckey" :class="['city',selAreaIndex==ckey?'city-active':'']"
                  @click.stop="onArea(item,ckey,false)">{{item.shortName}}</div>
              </div>
            </div>
          </template>

          <template v-if="filterIndex=='1'">
            <div class="flex pad-15">
              <span v-for="(item,i) in sexList" :key="i" :class="['label-filter',selSexIndex==i?'span-active':'']"
                @click="onSex(i)">{{item}}</span>
            </div>
          </template>
          <template v-if="filterIndex=='2'">
            <div class="flex pad-15">
              <span v-for="(item,n) in priceList" :key="n" :class="['label-filter',selPriceIndex==n?'span-active':'']"
                @click="onPrice(n)">{{item}}</span>
            </div>
          </template>
          <template v-if="filterIndex=='3'">
            <div class="pad-15" :style="'overflow-y: scroll;max-height:'+(Height-220)+'px'">
              <span class="title">咨询类型</span>
              <div class="flex wrap">
                <span v-for="(item,b) in CONSULT_TYPE" :key="b" :class="['label-filter',item.selected?'span-active':'']"
                  @click="onConsult(item,b,'CONSULT_TYPE')">{{item.dictDetailDescription}}</span>
              </div>

              <span class="title">咨询方式</span>
              <div class="flex wrap">
                <span v-for="(item,a) in CONSULT_FORM" :key="a" :class="['label-filter',item.selected?'span-active':'']"
                  @click="onConsult(item,a,'CONSULT_FORM')">{{item.dictDetailDescription}}</span>
              </div>

              <span class="title">技术取向</span>
              <div class="flex wrap">
                <span v-for="(item,c) in CONSULT_SUBJECT" :key="c"
                  :class="['label-filter',item.selected?'span-active':'',item.dictDetailDescription.length>=7?'fz-12':'fz-14']"
                  @click="onConsult(item,c,'CONSULT_SUBJECT')">{{item.dictDetailDescription}}</span>
              </div>

              <span class="title">咨询议题</span>
              <div class="flex wrap">
                <span v-for="(item,d) in CONSULT_TOPIC" :key="d"
                  :class="['label-filter',item.selected?'span-active':'',item.dictDetailDescription.length>=7?'fz-12':'fz-14']"
                  @click="onConsult(item,d,'CONSULT_TOPIC')">{{item.dictDetailDescription}}</span>
              </div>

              <span class="title">咨询语言</span>
              <div class="flex wrap">
                <span v-for="(item,d) in CONSULT_LANG" :key="d"
                  :class="['label-filter',item.selected?'span-active':'',item.dictDetailDescription.length>=7?'fz-12':'fz-14']"
                  @click="onConsult(item,d,'CONSULT_LANG')">{{item.dictDetailDescription}}</span>
              </div>

            </div>
          </template>
        </template>

        <div class="flex between" v-if="show"><span class="btn-normal" @click.stop="onReset">重置</span><span
            class="btn-normal btn-filter" @click.stop="onFilter">确定</span></div>
      </div>
    </div>
    <div class="filterMask" :style='"height:"+Height+"px"' @click.stop="onCancelFixed" v-if="show"></div>
  </div>
</template>

<script>
  import {
    Toast
  } from 'mint-ui';
  import {
    getRegion,
    getDictList,
    getDictDetailList
  } from '../service/api'
  export default {
    name: 'ListFilter',
    props: {
      data: {
        type: Array,
        default: function () {
          return []
        },
      },

    },
    data() {
      return {
        filterIndex: '',
        Height: document.documentElement.clientHeight,
        selProvinceIndex: 0, //选择省的index
        selCityIndex: 0, //选择市的index
        selAreaIndex: 0, //选择县级市的index
        selSexIndex: sessionStorage.getItem('SexIndex') || 0, //选择性别的index
        selPriceIndex: sessionStorage.getItem('PriceIndex') || 0, //选择价格的index
        selForm: -1,
        selType: -1,
        selSubject: -1,
        selTopic: -1,
        selLang: -1,
        // provinceIndex: Number(sessionStorage.getItem('provinceIndex')) || 0, //地区控件默认省份的index
        // cityIndex: Number(sessionStorage.getItem('cityIndex')) || 0, //地区控件默认城市的index
        // areaIndex: Number(sessionStorage.getItem('areaIndex')) || 0, //地区控件默认县级市的index
        // 省市区
        province: [],
        city: [],
        area: [],
        sexList: ['不限', '男', '女'],
        priceList: ['不限', '500及以下', '501-800', '801-1000', '1000及以上'],
        CONSULT_FORM: [],
        CONSULT_TYPE: [],
        CONSULT_SUBJECT: [],
        CONSULT_TOPIC: [],
        CONSULT_LANG: [],
        consult_type: [],
        consult_form: [],
        consult_subject: [],
        consult_topic: [],
        consult_lang: [],
        consultList: [],
        CONSULT_LIST: [],
        show: false, //展开筛选的条件
        body: {
          provinceId: '110000',
          cityId: '110100',
          countyId: '',
          gender: '',
          priceFrom: '',
          priceTo: '',
          consultFormCodeList: [],
          consultTypeCodeLit: [],
          consultSubjectCodeList: [],
          consultTopicCodeList: [],
          consultLangCodeList: [],
          pagination: {
            pageNo: 1,
            pageSize: 5
          }
        }
        // dictList:[]
      }
    },
    mounted() {
      // 获取省市区
      this.getProvince()
      this.getCity({
        regionCode: sessionStorage.getItem('provinceId') || "110000"
      }, sessionStorage.getItem('ProvinceIndex') || 0, true)
      this.getArea({
        regionCode: sessionStorage.getItem('cityId') || "110100"
      }, sessionStorage.getItem('CityIndex') || 0, true)
      // this.onArea({
      //   regionCode: sessionStorage.getItem('countyId') || ''
      // }, sessionStorage.getItem('AreaIndex') || 0, true)
      // 获取筛选数据
      this.dictDetailList()

    },
    methods: {
      dictDetailList() {
        getDictDetailList().then(res => {
          this.CONSULT_LIST = res.dictDetailList.map(item => {
            return item = {
              dictDetailDescription: item.dictDetailDescription,
              dictDetailCode: item.dictDetailCode,
              dictCode: item.dictCode
            }
          })
          getDictList().then(data => {
            this.CONSULT_FORM = this.CONSULT_FORM.concat(this.CONSULT_LIST.filter(item => {
              return item.dictCode == 'CONSULT_FORM'
            }))
            this.CONSULT_TYPE = this.CONSULT_TYPE.concat(this.CONSULT_LIST.filter(item => {
              return item.dictCode == 'CONSULT_TYPE'
            }))
            this.CONSULT_SUBJECT = this.CONSULT_SUBJECT.concat(this.CONSULT_LIST.filter(item => {
              return item.dictCode == 'CONSULT_SUBJECT'
            }))
            this.CONSULT_TOPIC = this.CONSULT_TOPIC.concat(this.CONSULT_LIST.filter(item => {
              return item.dictCode == 'CONSULT_TOPIC'
            }))
            this.CONSULT_LANG = this.CONSULT_LANG.concat(this.CONSULT_LIST.filter(item => {
              return item.dictCode == 'CONSULT_LANG'
            }))

            // 缓存筛选类型数据
            if (sessionStorage.getItem('CONSULT_FORM')) {
              this.selForm = 1
              const seleted_form = JSON.parse(sessionStorage.getItem('CONSULT_FORM'))
              this.CONSULT_FORM.map(item => {
                seleted_form.map(k => {
                  if (item.dictDetailDescription == k.dictDetailDescription) {
                    this.$set(item, 'selected', true)
                  }
                })
              })
            }

            if (sessionStorage.getItem('CONSULT_TYPE')) {
              this.selType = 1
              const seleted_type = JSON.parse(sessionStorage.getItem('CONSULT_TYPE'))
              this.CONSULT_TYPE.map(item => {
                seleted_type.map(k => {
                  if (item.dictDetailDescription == k.dictDetailDescription) {
                    this.$set(item, 'selected', true)
                  }
                })
              })
            }

            if (sessionStorage.getItem('CONSULT_SUBJECT')) {
              this.selSubject = 1
              const seleted_subject = JSON.parse(sessionStorage.getItem('CONSULT_SUBJECT'))
              this.CONSULT_SUBJECT.map(item => {
                seleted_subject.map(k => {
                  if (item.dictDetailDescription == k.dictDetailDescription) {
                    this.$set(item, 'selected', true)
                  }
                })
              })
            }

            if (sessionStorage.getItem('CONSULT_TOPIC')) {
              this.selTopic = 1
              const seleted_topic = JSON.parse(sessionStorage.getItem('CONSULT_TOPIC'))
              this.CONSULT_TOPIC.map(item => {
                seleted_topic.map(k => {
                  if (item.dictDetailDescription == k.dictDetailDescription) {
                    this.$set(item, 'selected', true)
                  }
                })
              })
            }

            if (sessionStorage.getItem('CONSULT_LANG')) {
              this.selLang = 1
              const seleted_lang = JSON.parse(sessionStorage.getItem('CONSULT_LANG'))
              this.CONSULT_LANG.map(item => {
                seleted_lang.map(k => {
                  if (item.dictDetailDescription == k.dictDetailDescription) {
                    this.$set(item, 'selected', true)
                  }
                })
              })
            }

          })
        })
      },
      getProvince(item) {
        getRegion({
          parentCode: "100000"
        }).then(res => {
          this.province = [{
            id: '',
            shortName: '不限',
            regionCode: ''
          }].concat(res.regionList)
          this.provinceId = ""
        })
      },
      // 获取地级市数据
      getCity(item, index, flag) {
        if (index == 0 && !flag) {
          this.body.provinceId = ""
          this.body.cityId = ""
          this.body.countyId = ""
          //省份、地级市、县级市id默认初始化为0
          this.selProvinceIndex = 0
          this.selCityIndex = 0
          this.selAreaIndex = 0
          return
        }
        getRegion({
          parentCode: item.regionCode //默认北京
        }).then(res => {
          this.city = [{
            id: '',
            shortName: '不限',
            regionCode: ''
          }].concat(res.regionList)
          this.selProvinceIndex = index
          //地级市跟县级市id默认初始化为0
          this.selCityIndex = 0
          this.selAreaIndex = 0
          //地级市跟县级市regionCode默认初始化为第一个对象的值
          this.body.provinceId = item.regionCode
          // this.body.cityId = this.city[0].regionCode
          this.body.cityId = ""
          this.body.countyId = ""
          this.getArea(this.city[sessionStorage.getItem('CityIndex') || 1], sessionStorage.getItem('AreaIndex') ||
            0, true)
          if (flag) {
            this.body.provinceId = sessionStorage.getItem('provinceId') || ""
          }
        })
      },
      // 获取县级市数据
      getArea(item, index, flag) {
        if (index == 0 && !flag) {
          this.body.cityId = ""
          this.body.countyId = ""
          //省份、地级市、县级市id默认初始化为0
          this.selCityIndex = 0
          this.selAreaIndex = 0
          this.areaIndex = 0
          return
        }
        // sessionStorage.setItem('cityId', item.regionCode)
        getRegion({
          parentCode: item.regionCode //默认北京
        }).then(res => {
          this.area = [{
            id: '',
            shortName: '不限',
            regionCode: ''
          }].concat(res.regionList)
          this.selCityIndex = index
          this.selAreaIndex = 0
          //县级市id默认初始化为0
          this.areaIndex = index
          //县级市regionCode默认初始化为第一个对象的值
          this.body.cityId = item.regionCode
          this.body.countyId = ""
          // this.onArea()
          if (flag) {
            this.body.cityId = sessionStorage.getItem('cityId') || ""
            this.selCityIndex = sessionStorage.getItem('CityIndex') || index
            this.selAreaIndex = sessionStorage.getItem('AreaIndex') || index
            this.body.countyId = sessionStorage.getItem('countyId') || ""
          }
        })
      },
      // 操作县市级数据
      onArea(item, index, flag) {
        this.selAreaIndex = index
        this.body.countyId = item.regionCode
        if (flag) {
          this.body.countyId = sessionStorage.getItem('countyId') || ""
          this.selAreaIndex = sessionStorage.getItem('AreaIndex') || index
        }
      },
      // 筛选出列表
      onFilter() {
        // if (this.filterIndex == 1 && this.selSexIndex == 0) {
        //   Toast('请选择性别')
        //   return
        // }
        // if (this.filterIndex == 2 && this.selPriceIndex == 0) {
        //   Toast('请选择价格')
        //   return
        // }
        // 缓存城市选择数据
        if (this.filterIndex == 0) {
          sessionStorage.setItem('ProvinceIndex', this.selProvinceIndex)
          sessionStorage.setItem('CityIndex', this.selCityIndex)
          sessionStorage.setItem('AreaIndex', this.selAreaIndex)
          sessionStorage.setItem('provinceId', this.body.provinceId)
          sessionStorage.setItem('cityId', this.body.cityId)
          sessionStorage.setItem('countyId', this.body.countyId)
        }

        if (this.filterIndex == 1) {
          sessionStorage.setItem('SexIndex', this.selSexIndex)
        }
        if (this.filterIndex == 2) {
          sessionStorage.setItem('PriceIndex', this.selPriceIndex)
        }
        if (this.filterIndex == 3) {
          if (this.selType != -1) sessionStorage.setItem('CONSULT_TYPE', JSON.stringify(this.consult_type))
          if (this.selForm != -1) sessionStorage.setItem('CONSULT_FORM', JSON.stringify(this.consult_form))
          if (this.selSubject != -1) sessionStorage.setItem('CONSULT_SUBJECT', JSON.stringify(this.consult_subject))
          if (this.selTopic != -1) sessionStorage.setItem('CONSULT_TOPIC', JSON.stringify(this.consult_topic))
          if (this.selLang != -1) sessionStorage.setItem('CONSULT_LANG', JSON.stringify(this.consult_lang))
          this.body.consultFormCodeList = []
          this.body.consultTypeCodeLit = []
          this.body.consultSubjectCodeList = []
          this.body.consultTopicCodeList = []
          this.body.consultLangCodeList = []
          const consult_type = this.CONSULT_TYPE.filter(item => {
            return item && item.selected
          })
          // if (consult_type.length == 0) {

          //   Toast('请选择咨询类型')
          //   return
          // }
          const consult_form = this.CONSULT_FORM.filter(item => {
            return item && item.selected
          })
          // if (consult_form.length == 0) {

          //   Toast('请选择咨询方式')
          //   return
          // }
          const consult_subject = this.CONSULT_SUBJECT.filter(item => {
            return item && item.selected
          })
          // if (consult_subject.length == 0) {

          //   Toast('请选择技术取向')
          //   return
          // }
          const consult_topic = this.CONSULT_TOPIC.filter(item => {
            return item && item.selected
          })
          // if (consult_topic.length == 0) {

          //   Toast('请选择咨询议题')
          //   return
          // }
          const consult_lang = this.CONSULT_LANG.filter(item => {
            return item && item.selected
          })
          // if (consult_topic.length == 0) {

          //   Toast('请选择咨询议题')
          //   return
          // }

          for (let i = 0; i < consult_type.length; i++) {
            this.body.consultTypeCodeLit.push(consult_type[i].dictDetailCode)
          }
          for (let n = 0; n < consult_form.length; n++) {
            this.body.consultFormCodeList.push(consult_form[n].dictDetailCode)
          }
          for (let l = 0; l < consult_subject.length; l++) {
            this.body.consultSubjectCodeList.push(consult_subject[l].dictDetailCode)
          }
          for (let m = 0; m < consult_topic.length; m++) {
            this.body.consultTopicCodeList.push(consult_topic[m].dictDetailCode)
          }
          for (let s = 0; s < consult_lang.length; s++) {
            this.body.consultLangCodeList.push(consult_lang[s].dictDetailCode)
          }
        }
        this.show = false
        this.$emit('filter', this.body)
      },
      // 重置筛选
      onReset() {
        if (this.filterIndex == 0) {
          this.body.provinceId = ""
          this.body.cityId = ""
          this.body.countyId = ""
          //省份、地级市、县级市id默认初始化为0
          this.selProvinceIndex = 0
          this.selCityIndex = 0
          this.selAreaIndex = 0
          sessionStorage.removeItem('ProvinceIndex')
          sessionStorage.removeItem('CityIndex')
          sessionStorage.removeItem('AreaIndex')
          sessionStorage.removeItem('provinceId')
          sessionStorage.removeItem('cityId')
          sessionStorage.removeItem('countyId')
          this.getProvince()
          this.getCity({
            regionCode:  "110000"
          },  0, true)
          this.getArea({
            regionCode: "110100"
          },  0, true)
        } else if (this.filterIndex == 1) {
          this.selSexIndex = 0
          this.body.gender = ""
          sessionStorage.removeItem('SexIndex')
        } else if (this.filterIndex == 2) {
          this.selPriceIndex = 0
          this.body.priceFrom = ''
          this.body.priceTo = ''
          sessionStorage.removeItem('PriceIndex')
        } else if (this.filterIndex == 3) {
          this.CONSULT_FORM.map(item => {
            this.$set(item, 'selected', false)
          })
          this.CONSULT_TYPE.map(item => {
            this.$set(item, 'selected', false)
          })
          this.CONSULT_SUBJECT.map(item => {
            this.$set(item, 'selected', false)
          })
          this.CONSULT_TOPIC.map(item => {
            this.$set(item, 'selected', false)
          })
          this.CONSULT_LANG.map(item => {
            this.$set(item, 'selected', false)
          })
          this.body.consultFormCodeList = []
          this.body.consultTypeCodeLit = []
          this.body.consultSubjectCodeList = []
          this.body.consultFormCodeList = []
          this.body.consultLangCodeList = []
          //选中样式重置
          this.selType = -1
          this.selForm = -1
          this.selSubject = -1
          this.selTopic = -1
          this.selLang = -1
          sessionStorage.removeItem('CONSULT_FORM')
          sessionStorage.removeItem('CONSULT_TYPE')
          sessionStorage.removeItem('CONSULT_SUBJECT')
          sessionStorage.removeItem('CONSULT_TOPIC')
          sessionStorage.removeItem('CONSULT_LANG')
        }
        //重置缓存参数
        sessionStorage.setItem('body', JSON.stringify(this.body))
      },
      // 性别筛选
      onSex(i) {
        this.selSexIndex = i
        if (i == 0) {
          this.body.gender = ''
        } else if (i == 1) {
          this.body.gender = 0
        } else {
          this.body.gender = 1
        }
      },
      // 价格筛选
      onPrice(i) {
        this.selPriceIndex = i
        if (i == 0) {
          this.body.priceFrom = ''
          this.body.priceTo = ''
        } else if (i == 1) {
          this.body.priceFrom = '0'
          this.body.priceTo = '500'
        } else if (i == 2) {
          this.body.priceFrom = '501'
          this.body.priceTo = '800'
        } else if (i == 3) {
          this.body.priceFrom = '801'
          this.body.priceTo = '1000'
        } else {
          this.body.priceFrom = '1000'
          this.body.priceTo = ''
        }
      },
      // 其他筛选
      onConsult(item, i, type) {
        switch (type) {
          case 'CONSULT_FORM':
            this.selForm = i
            break;
          case 'CONSULT_TYPE':
            this.selType = i
            break;
          case 'CONSULT_SUBJECT':
            this.selSubject = i
            break;
          case 'CONSULT_TOPIC':
            this.selTopic = i
            break;
          case 'CONSULT_LANG':
            this.selLang = i
            break;
        }
        if (!item.selected) {
          this.$set(item, 'selected', true)
        } else {
          this.$set(item, 'selected', false)
        }
        this.consult_type = this.CONSULT_TYPE.filter(item => {
          return item && item.selected
        })
        if (this.consult_type.length == 0) {
          this.selType = -1
        }
        this.consult_form = this.CONSULT_FORM.filter(item => {
          return item && item.selected
        })
        if (this.consult_form.length == 0) {
          this.selForm = -1
        }
        this.consult_subject = this.CONSULT_SUBJECT.filter(item => {
          return item && item.selected
        })
        if (this.consult_subject.length == 0) {
          this.selSubject = -1
        }
        this.consult_topic = this.CONSULT_TOPIC.filter(item => {
          return item && item.selected
        })
        if (this.consult_topic.length == 0) {
          this.selTopic = -1
        }
        this.consult_lang = this.CONSULT_LANG.filter(item => {
          return item && item.selected
        })
        if (this.consult_lang.length == 0) {
          this.selLang = -1
        }
      },
      onShowFilterCell(key) {
        this.filterIndex = key
        this.show = true
        this.$emit('fixed', true)
      },
      onCancelFixed() {
        this.filterIndex = ''
        this.show = false
        this.$emit('cancelFixed', false)
      },
      onClose() {
        this.$emit('close')
      }

    }
  };

</script>

<style lang="stylus">
  @import '../stylus/components/listFilter.styl'

</style>



// WEBPACK FOOTER //
// src/components/ListFilter.vue